<script lang="ts">
	import SettingsRenderer from 'src/components/Settings/shared/SettingsRenderer.svelte';
	import { userSettingsConfig } from 'src/configs/settings/UserSettingsConfig';
</script>

<SettingsRenderer config={userSettingsConfig.legacy} variant="legacy" />
